<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-home-popup modal-mask" @click="hide()" v-if="isActive">
            <button class="btn-close" @click="hide()"><i class="pe-7s-close"></i></button>
            <div class="block">
                <img :src="fields.imageUrl" :alt="fields.imageTitle" :title="fields.imageTitle" @click.stop />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        fields: Object
    },
    watch: {
        isDisplay(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    created() {
        let page = this;
        let isSeen = this.$cookie.get('homePopup');

        setTimeout(function(){
            if (page.fields.imageUrl && !isSeen) {
                page.show();
            }
        }, this.$WeConfig.TimeLoader); 
    },
    methods: {
        show() {
            this.isActive = true;
        },
        hide() {
            this.$cookie.set('homePopup', true, 1);
            this.isActive = false;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.modal-home-popup {
    .btn-close {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 10px;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        font-size: 34px;
        line-height: 30px;
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
    }

    .block {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;

        img {
            display: block;
            margin: auto;
            max-width: 100%;
        }
    }
}
</style>